import React from "react";

// styles
import styles from "./DocumentLink.module.scss";
import cx from "classnames";
import Icon from "../Icon/Icon";

interface IDocumentProps {
    title: string;
    documentUrl: string;
    thumbnailUrl: string;
    style?: "horizontal" | "vertical"; // Default is horizontal
    className?: string;
}

const DocumentLink: React.FC<IDocumentProps> = (props) => {
    const { title, documentUrl, thumbnailUrl, className } = props;

    const style = props.style || "horizontal";

    return (
        <a
            target="_blank"
            href={documentUrl}
            rel="noopener"
            className={cx([
                "text-font-size-xs",
                {
                    "layout-flex-row--centered": style === "horizontal",
                    "layout-flex-column--centered": style === "vertical",
                    [className]: !!className
                }
            ])}>
            <div
                className={cx([
                    styles["document-thumbnail"],
                    {
                        ["space-m"]: style === "horizontal",
                        ["gap-s"]: style === "vertical"
                    }
                ])}>
                <img
                    className={styles["document-thumbnail__icon"]}
                    src={thumbnailUrl}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src =
                            "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDE2IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5pY29uLW11bHRpLXBvbGljeS1kaXNjb3VudDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJkZWZhdWx0LWJhc2ljcy12aWV3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjE3LjAwMDAwMCwgLTQ0OS4wMDAwMDApIiBmaWxsPSIjMTZBRThGIj4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMTksNDUyIEwyMTksNDY2IEwyMjgsNDY2IEwyMjgsNDY4IEwyMTcsNDY4IEwyMTcsNDUyIEwyMTksNDUyIFogTTIyOSw0NDkgTDIzMyw0NTMgTDIzMyw0NjUgTDIyMCw0NjUgTDIyMCw0NDkgTDIyOSw0NDkgWiBNMjI3LDQ1MSBMMjIyLDQ1MSBMMjIyLDQ2MyBMMjMxLDQ2MyBMMjMxLDQ1NSBMMjI3LDQ1NSBMMjI3LDQ1MSBaIE0yMjguNSw0NTEuMDAyIEwyMjguNSw0NTMuNSBMMjMxLDQ1My41IEwyMjguNSw0NTEuMDAyIFoiIGlkPSJpY29uLW11bHRpLWJlbmVmaXQtZGlzY291bnQiPjwvcGF0aD4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==";
                    }}
                    alt="Document"
                />
            </div>
            <span
                className={cx([
                    "layout-flex-row--centered",
                    styles["document-text-row"]
                ])}>
                {title} <Icon id="ExternalLink" />
            </span>
        </a>
    );
};

export default DocumentLink;
